/**
 * 是否允许发起申诉
 * - 仅审核明细 3（审核驳回、尚未申诉）可申诉一次
 * - 5 申诉中、6 申诉通过、7 申诉未通过：不可再次申诉（7 仅可修改送审资料后重新送审，不可二次申诉）
 */
export function canInitiateAppeal(row) {
  if (!row) return false
  if (row.reviewStatusApi != null && row.reviewStatusApi !== '') {
    return Number(row.reviewStatusApi) === 3
  }
  if (typeof row.reviewStatus === 'number') {
    return row.reviewStatus === 3
  }
  return false
}

/** 申诉提交成功后列表应展示的审核明细状态 */
export const REVIEW_STATUS_AFTER_APPEAL_SUBMIT = 5

/** TT 申诉反馈通过时列表/记录态 */
export const REVIEW_STATUS_APPEAL_PASSED = 6

/** TT 申诉反馈维持驳回时列表/记录态 */
export const REVIEW_STATUS_APPEAL_REJECTED = 7

/** 申诉提交 body.ttVersion（审核记录 ttVersion / 列表 reviewTtVersion / rejectVersion） */
export function resolveAppealTtVersion(row) {
  if (!row) return undefined
  const candidates = [row.ttVersion, row.reviewTtVersion, row.rejectVersion]
  for (let i = 0; i < candidates.length; i += 1) {
    const raw = candidates[i]
    if (raw == null || raw === '') continue
    const text = String(raw).trim()
    const vMatch = text.match(/^v?(\d+)$/i)
    if (vMatch) {
      const n = Number(vMatch[1])
      if (!Number.isNaN(n) && n > 0) return n
    }
    const n = Number(raw)
    if (!Number.isNaN(n) && n > 0) return n
  }
  return undefined
}

export function formatAppealVersionLabel(row) {
  if (!row) return '—'
  const rejectVersion = row.rejectVersion
  if (rejectVersion != null && rejectVersion !== '') {
    const text = String(rejectVersion).trim()
    return /^V/i.test(text) ? text.toUpperCase() : `V${text}`
  }
  const ttVersion = row.reviewTtVersion
  if (ttVersion != null && Number(ttVersion) > 0) {
    return `V${ttVersion}`
  }
  return '—'
}
